import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material'; // Removed Paper
import { Link as RouterLink } from 'react-router-dom';
import GlassCard from '../../../ui/glass/components/GlassCard';
import { formatCurrency } from '../../../utils/formatters';

const DuePaymentCard = ({ serviceRecord }) => (
    <MuiLink component={RouterLink} to={`/servis-kaydi/${serviceRecord.id}`} sx={{ textDecoration: 'none' }}>
        <GlassCard
            sx={{
                p: 1.5,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                // GlassCard has default hover effect, but we can enhance or rely on it
            }}
        >
            <Box>
                <Typography variant="body2" fontWeight="bold">
                    {serviceRecord.musteriAdSoyad}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    {serviceRecord.cihazSeriNumarasi}
                </Typography>
            </Box>
            <Typography color="error.main" fontWeight="bold">
                {formatCurrency(serviceRecord.kalanTutar)}
            </Typography>
        </GlassCard>
    </MuiLink>
);

export default DuePaymentCard;
